import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from '@ant-design/icons'
import classNames from 'classnames'
import type { ReactNode } from 'react'

import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './AtomNotice.module.scss'

type AtomNoticeType = 'info' | 'success' | 'warning' | 'error'

const ICONS: Record<AtomNoticeType, ReactNode> = {
  info: <InfoCircleFilled />,
  success: <CheckCircleFilled />,
  warning: <ExclamationCircleFilled />,
  error: <CloseCircleFilled />,
}

type AtomNoticeProps = {
  type?: AtomNoticeType
  children: ReactNode
  description?: ReactNode
  action?: ReactNode
}

function AtomNotice({
  type = 'info',
  children,
  description,
  action,
}: AtomNoticeProps) {
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )

  return (
    <div
      role={type === 'error' ? 'alert' : 'status'}
      className={classNames(
        cn.notice,
        cn[type],
        isOrganisationSelected && cn.accentSelected
      )}
    >
      <span className={cn.icon} aria-hidden>
        {ICONS[type]}
      </span>
      <div className={cn.text}>
        <div>{children}</div>
        {description && <div className={cn.description}>{description}</div>}
      </div>
      {action && <div className={cn.action}>{action}</div>}
    </div>
  )
}

export default AtomNotice
